module.exports = __webpack_public_path__ + "static/img/Note.f2555533.png";